"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);








var _time = require('shared/services/time');

 const PAGE_SIZE = 50; exports.PAGE_SIZE = PAGE_SIZE
// The most patients one bulk action covers (D-14), as the server enforces.
 const MAX_PER_ACTION = 20000; exports.MAX_PER_ACTION = MAX_PER_ACTION

 const formatCount = (n) => n.toLocaleString('en-US'); exports.formatCount = formatCount

 const formatDOB = (dob) => _time.isDateNull.call(void 0, dob) ? '' : _time.formatDisplayDate.call(void 0, dob); exports.formatDOB = formatDOB

// "Jan 1, 2026"
 const formatDay = (iso) => iso && !_time.isDateNull.call(void 0, iso) ? _moment2.default.call(void 0, iso).format('MMM D, YYYY') : ''; exports.formatDay = formatDay

// "Oct 15, 4:59 PM" this year, "Oct 15, 2025" before; "—" when never.
 const formatActivity = (iso, now = _moment2.default.call(void 0, )) => {
  if (!iso || _time.isDateNull.call(void 0, iso)) return '—'
  const at = _moment2.default.call(void 0, iso)
  return at.year() === now.year() ? at.format('MMM D, h:mm A') : at.format('MMM D, YYYY')
}; exports.formatActivity = formatActivity

 const TEXTING_LABELS = {
  deliverable: 'Deliverable',
  opted_out: 'Opted out',
  blocked: 'Blocked by admin',
  cant_receive: 'Can\'t receive texts',
  no_phone: 'No phone',
}; exports.TEXTING_LABELS = TEXTING_LABELS

 const APP_USE_LABELS = {
  app_user: 'App user',
  not_app_user: 'Not an app user',
}; exports.APP_USE_LABELS = APP_USE_LABELS

// The status pill's colour: the broadcast recipients table's pills.
 const TEXTING_PILLS = {
  deliverable: 'campaign--table--status-pill-ready',
  opted_out: 'campaign--table--status-pill-invalid',
  blocked: 'campaign--table--status-pill-invalid',
  cant_receive: 'campaign--table--status-pill-missing',
  no_phone: 'campaign--table--status-pill-not-scheduled',
}; exports.TEXTING_PILLS = TEXTING_PILLS

 const hasFilters = (filter) => !!(
  _optionalChain([filter, 'access', _ => _.TagKeys, 'optionalAccess', _2 => _2.length]) || filter.CreatedFrom || filter.CreatedTo
  || filter.LastActivityFrom || filter.LastActivityTo || _optionalChain([filter, 'access', _3 => _3.Texting, 'optionalAccess', _4 => _4.length])
  || _optionalChain([filter, 'access', _5 => _5.AppUse, 'optionalAccess', _6 => _6.length])
); exports.hasFilters = hasFilters

const joinOr = (names) => names.length < 2
  ? names.join('')
  : `${names.slice(0, -1).join(', ')} or ${names[names.length - 1]}`

/* How the footer, the Select-all banner and the dialogs name what the search
 * and filters match: "tagged Flu shot 2026", "matching \u201CHamilton\u201D", or
 * "matching your filters". Empty when nothing narrows the view. */
 const describeFilter = (filter, tags) => {
  const query = _optionalChain([filter, 'access', _7 => _7.Query, 'optionalAccess', _8 => _8.trim, 'call', _9 => _9()])
  const tagKeys = filter.TagKeys || []
  const onlyTags = tagKeys.length > 0 && !query && !exports.hasFilters.call(void 0, { ...filter, TagKeys: [] })
  if (onlyTags) {
    const byKey = new Map(tags.map(t => [t.TagKey, t.Name]))
    const names = tagKeys.map(k => byKey.get(k)).filter((n) => !!n)
    if (names.length === tagKeys.length) return `tagged ${joinOr(names)}`
  }
  if (query && !exports.hasFilters.call(void 0, filter)) return `matching \u201C${query}\u201D`
  if (query || exports.hasFilters.call(void 0, filter)) return query ? 'matching your search and filters' : 'matching your filters'
  return ''
}; exports.describeFilter = describeFilter

/* "patients", "archived patients", "patients tagged Flu shot 2026". */
 const patientsNoun = (count, isArchived, description) => [
  isArchived ? 'archived' : '',
  count === 1 ? 'patient' : 'patients',
  description,
].filter(Boolean).join(' '); exports.patientsNoun = patientsNoun
